module.exports = __webpack_public_path__ + "img/chart@2x.bdc708de.png";